import { useRef } from 'react';
import { find } from 'lodash';
import { useSelector } from 'react-redux';
import MultiSelect from "../Inputs/MultiSelect";
import SelectOption from "../Inputs/SelectOption";
import MultiselectChip from "../MultiselectChip";
import useCalculateEllipsis from "../../hooks/useCalculateEllipsis";

const FilterServicesDropdown = (props) => {
    const {
        onChange,
        onDelete,
        id,
        options,
        defaultSelection,
        optionValueKey,
        optionsToFilterResultsFrom,
        placeholder,
        highlight = false,
        isDefaultOpen = false
    } = props;
    const loading = useSelector(state => state.search.loading);

    const refs = useRef(new Map());
    const selectButtonRef = useRef(null);

    const showEllipsis = useCalculateEllipsis(selectButtonRef, refs, defaultSelection)

    const handleDelete = (id) => {
        refs.current.delete(id)
        return onDelete(id)
    }

    return (
            <MultiSelect
                ref={selectButtonRef}
                defaultSelection={[...defaultSelection]}
                onSelection={onChange}
                id={id}
                options={options}
                renderOption={(option, isSelected, disabled) => (<SelectOption label={option.label} isSelected={isSelected} disabled={disabled} />)}
                optionValueKey={optionValueKey}
                disabled={loading}
                showEllipsis={showEllipsis}
                highlight={highlight && defaultSelection.length === 0}
                isDefaultOpen={isDefaultOpen && defaultSelection.length === 0}
                renderValue={ () => (
                    <>
                        {defaultSelection.length === 0 && <span className={`${highlight ? 'font-bold' : ''} flex text-base items-center h-full`}>{placeholder}</span>}
                        {
                            defaultSelection.length > 0 &&
                            defaultSelection.map(value => {
                                const option = find(optionsToFilterResultsFrom, (item) => item.id === value );
                                if (!option) return null
                                return (
                                    <MultiselectChip
                                        ref={el => {
                                            if (!refs.current.get(value)) {
                                                refs.current.set(value, el)
                                            }
                                        }}
                                        key={option.id}
                                        label={option.label}
                                        onDelete={handleDelete(option.id)}
                                    />
                                )
                            })
                        }
                    </>
                )}
            />
    );
};

export default FilterServicesDropdown;
